// extracted by mini-css-extract-plugin
export default {"FixedSizeVirtualList":"RefsList-module__FixedSizeVirtualList--P_Ami"};